export const hasFourNumberCharacters = (input: string) => {
    return input.replace(/[^0-9]/g, '')?.length === 4
}
export const isCharacterNumberOrColon = (input: string) => {
    return /^[0-9:]$/.test(input)
}
export const isNumberOrLetterKey = (input: string) => {
    return /^[a-zA-Z0-9]$/.test(input)
}
